import { useFormikContext } from 'formik';

import { AccountPurchase } from '../models/account-purchase';
import { ReceiptNoteType } from '../../../common/models/enums/receipt-note-type';
import { paloDraftNoteIds, usePaloDraftNotices } from '../../../common/components/palo/palo-draft-notices';
import { useAppSelector } from '../../../store/use-appstate-selector';

/**
 * Asks for the notes of the customers, contacts and articles the customer
 * cards hold, so they stand in the head before the first save (#2236). The
 * suppliers are picked on a tab of their own and count as saved.
 *
 * It draws nothing.
 */
export const PaloInquiryNotesWatcher = (): null => {
    const { values } = useFormikContext<{ accountPurchases: AccountPurchase[] }>();
    const saved = useAppSelector(state => state.inquiries.entity);
    const purchases = values.accountPurchases ?? [];
    const suppliers = saved?.supplierAccounts ?? [];

    usePaloDraftNotices(
        ReceiptNoteType.Inquiries,
        paloDraftNoteIds({
            accountIds: [
                ...purchases.map(purchase => purchase.customerAccount?.id),
                ...suppliers.map(supplier => supplier.account?.id),
            ],
            contactIds: [
                ...purchases.flatMap(purchase => [purchase.contact?.id, purchase.avisoContact?.id]),
                ...suppliers.map(supplier => supplier.contact?.id),
                saved?.responsibleContact?.id,
            ],
            productIds: purchases.flatMap(purchase => (purchase.purchaseItems ?? []).map(item => item.product?.id)),
        })
    );

    return null;
};
